// Here we chose to use the native `structuredClone` function,
// but if we spot any compatibility issue, we can fallback to:
// export { default as cloneDeep } from 'lodash/cloneDeep.js'

const cloneDeep = structuredClone

export { cloneDeep }
